module.exports = __webpack_public_path__ + "static/media/Star.c2418874.png";